export const uiEmailSignup = {
    name: 'UI Email Signup',
    description: '',
    displayField: 'emailLabel',
    fields: {
        emailLabel: {
            name: 'Email Label',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        buttonText: {
            name: 'Button Text',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        redirectUrl: {
            name: 'Redirect Url',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        method: {
            name: 'Method',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ in: ['GET', 'POST'] }]
        },
        centered: {
            name: 'Centered',
            type: 'Boolean',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        }
    }
};
//# sourceMappingURL=uiEmailSignup.js.map